import React from 'react';

import { MarkedListContainer } from './styles';

export const LightMarkedList = (props) => {
    return <MarkedListContainer>{props.children}</MarkedListContainer>;
};
